import { render, staticRenderFns } from "./BrandSummarySection.vue?vue&type=template&id=64761efa&scoped=true"
import script from "./BrandSummarySection.vue?vue&type=script&lang=js"
export * from "./BrandSummarySection.vue?vue&type=script&lang=js"
import style0 from "./BrandSummarySection.vue?vue&type=style&index=0&id=64761efa&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64761efa",
  null
  
)

export default component.exports